export enum Theme {
    DARK = 'dark',
    DEFAULT = 'default'
  }